import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import _ from 'lodash';
import classnames from 'classnames';
import { useSelector } from 'react-redux';


import { Intl } from 'components';

export default ( { data, isLoading , onDelete} ) => {
  
    const data1 = useSelector(state=>state)
  
  return (
  <Container
    fluid
    className={classnames( { 'app-component-loading': isLoading } )}
  >
  
    <Row>
      <Col>
        <p className="mb-1"><Intl id="integrationSettings" /></p>

        <Row>
          {_.map( data, ( plugin ) => (
            <Col
              key={plugin.id}
              md={4}
            >
              <div
                className="pb-5 px-2 pt-2 position-relative"
                style={{ border: '1px solid #ccc', minHeight: 240 }}
              >
                <img src={plugin.logo} alt={plugin.name} width={200} />
                <p className="mt-3 text-sm">
                  {data1.settings.locale.locale==="en"? plugin.description:plugin.descriptionEs}
                </p>
                  {/* <p className="mt-3 text-sm">
                 <Intl id="description">{plugin.id}</Intl> 
        
                </p>  */}

                <div style={{
                  position: 'absolute', bottom: 20, left: 10, right: 10,
                }}
                >
                  <Row className="align-items-center pt-2">
                    <Col md="auto">
                      {plugin.isActivate ? <button className="btn-app-default btn-app-sm font-weight-bold cursor-pointer" onClick={()=>onDelete(plugin.id)}><Intl id="disconnect" /></button>:<p className="m-0 text-mp-gray-2 font-weight-bold"><Intl id="disconnected" /></p>}
                    </Col>
                    <Col md className="text-right">
                      <a
                        href={plugin.helpUri}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-app-default btn-app-sm font-weight-bold"
                      >
                        <Intl id="help" />
                      </a>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          ) )}
        </Row>
      </Col>
    </Row>
  </Container>
)

}
;
